import { BOSS_MODALS } from "./boss"
import { CHAT_MODALS } from "./chat"
import { CLAN_MODALS } from "./clan"
import { GIFT_MODALS } from "./gift"
import { HOME_MODALS } from "./home"
import { GAME_MODALS } from "./mine"
import { USER_MODALS } from "./user"
import { COMMON_MODALS } from "./common"
import { RECIPE_MODALS } from "./recipe"
import { APPAREL_MODALS } from "./apparel"
import { AUCTION_MODALS } from "./auction"
import { MISSION_MODALS } from "./mission"
import { STAKING_MODALS } from "./staking"
import { INVENTORY_MODALS } from "./inventory"
import { SALE_CHEST_MODALS } from "./sale-chest"
import { EXPEDITION_MODALS } from "./expeditions"
import { CLASH_OF_DIGGERS_MODALS } from "./clashOfDiggers"

export const MODAL_CONFIG = {
  ...HOME_MODALS,
  ...BOSS_MODALS,
  ...CLAN_MODALS,
  ...INVENTORY_MODALS,
  ...STAKING_MODALS,
  ...GAME_MODALS,
  ...EXPEDITION_MODALS,
  ...USER_MODALS,
  ...CHAT_MODALS,
  ...COMMON_MODALS,
  ...AUCTION_MODALS,
  ...RECIPE_MODALS,
  ...APPAREL_MODALS,
  ...GIFT_MODALS,
  ...CLASH_OF_DIGGERS_MODALS,
  ...MISSION_MODALS,
  ...SALE_CHEST_MODALS
} as const

export const ALL_MODALS = Object.keys(
  MODAL_CONFIG
) as (keyof typeof MODAL_CONFIG)[]
export type ModalType = keyof typeof MODAL_CONFIG

export type GetModalComponent<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { component: infer C } ? C : never

export type GetModalParams<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { params: infer P } ? P : undefined

export type GetModalInRouter<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { inRouter: infer R } ? R : true

export type HasComponent<T extends ModalType> =
  (typeof MODAL_CONFIG)[T] extends { component: any } ? true : false

export const MODAL_PARAMS_MAP = Object.entries(MODAL_CONFIG).reduce(
  (acc, [name, config]) => {
    if ("params" in config) {
      acc[name] = (config as any).params
    }
    return acc
  },
  {} as Record<string, any>
)

export {
  HOME_MODALS,
  BOSS_MODALS,
  CLAN_MODALS,
  INVENTORY_MODALS,
  STAKING_MODALS,
  GAME_MODALS,
  EXPEDITION_MODALS,
  USER_MODALS,
  CHAT_MODALS,
  COMMON_MODALS,
  CLASH_OF_DIGGERS_MODALS,
  MISSION_MODALS,
  SALE_CHEST_MODALS
}
